import React from 'react'
import { Box, Stack } from '@mui/material'
import { Link } from 'react-router-dom'
import { merchantTopNavLinkSx } from './merchantFormStyles'

const controlSx = {
  ...merchantTopNavLinkSx,
  border: 0,
  background: 'none',
  padding: 0,
  fontFamily: 'inherit',
  textAlign: 'left',
  cursor: 'pointer',
  '&:disabled': {
    opacity: 0.5,
    cursor: 'default'
  }
}

/**
 * Wayfinding row for native ABR pages. Sits above the page title.
 * Back is always the left slot. Pass `actions` for the page's real controls.
 */
const PageBackRow = ({
  to,
  state,
  onClick,
  label = '< Back',
  actions = null,
  disabled = false,
  sx
}) => {
  const control = to && !disabled ? (
    <Box component={Link} to={to} state={state} onClick={onClick} sx={controlSx}>
      {label}
    </Box>
  ) : (
    <Box component="button" type="button" onClick={onClick} disabled={disabled} sx={controlSx}>
      {label}
    </Box>
  )

  return (
    <Stack
      direction="row"
      spacing={1}
      alignItems="center"
      justifyContent="space-between"
      sx={{ width: '100%', alignSelf: 'stretch', minHeight: '1.6rem', ...sx }}
    >
      {control}
      {actions ? (
        <Box sx={{ display: 'flex', alignItems: 'center', flexShrink: 0, gap: 0.75 }}>
          {actions}
        </Box>
      ) : null}
    </Stack>
  )
}

export default PageBackRow
